import React, { Fragment,  useState, useRef, useEffect, useContext, useCallback, useMemo } from "react";
import { AppContext } from "../../../../components/AppProvider";
import {  _API, _CK, _U, _AC } from "../../../../modules/utils";
import SessionListDetail from "./SessionList.Detail";
import Modal from "../../../../components/UI/preReg/Modal";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import RegisterAccompanyAttendModal from "../../../../components/register/Register.AccompanyingAttendModal";
import swal from "sweetalert";
import LoadingShimmer from "../../../../components/UI/LoadingShimmer";

import SpeakerModal from "../../../../components/register/Speaker.Modal";
import EboothModal from "../../../../components/register/Ebooth.Modal";

import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from "swiper";

import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import "swiper/components/scrollbar/scrollbar.scss";
import ImgPhoto from "../../../../resources/console/images/icon/default-user.svg";
import useStore from "../../../../modules/utils/store";
import Cookies from "universal-cookie";
import moment from "moment";
import { result } from "lodash";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

export default (props) => {
  const cm = new Cookies();
  const { auth, iam } = useContext(AppContext);
  const checkEventAccessCalled = useRef(false);
  const { saveAuth, saveIam } = useContext(AppContext);
  const { siteInfo } = useStore();
  const { history, match, sessionInfo } = props;
  // 사이트 정보

  // 이벤트 정보
  const [eventInfo, setEventInfo] = useState({});

  // 세션 리스트
  const [sessionList, setSessionList] = useState([]);
  // 사전등록 세션 리스트
  const [preregSessionList, setPreregSessionList] = useState([]);
  // ✅ 사전등록 정보 (한 번만 조회해서 자식 컴포넌트에 전달)
  const [preregInfo, setPreregInfo] = useState(null);

  const [managerInfo, setManagerInfo] = useState(null);
  const [sessionMgrInfoModalShow, setSessionMgrInfoModalShow] = useState(false);
  const [eboothModalShow, setEboothModalShow] = useState(false);
  const [accompanyAttendModal, setAccompanyAttendModal] = useState(false);
  const [accompanySessionIdx, setAccompanySessionIdx] = useState();
  const [loaded, setLoaded] = useState(false);
  const [eventInfoLoaded, setEventInfoLoaded] = useState(false);

  // E Booth 정보
  const [eboothEventSetting, setEboothEventSetting] = useState(null);
  const [eboothSiteSetting, setEboothSiteSetting] = useState(null);
  const [eboothSectionItem, setEboothSectionItem] = useState(null);
  const [eboothItem, setEboothItem] = useState(null);
  const [eboothList, setEboothList] = useState(null);

  const [allBtnSelected, setAllBtnSelected] = useState(false);
  const [tags, setTags] = useState([]);

  const Modalstyle = {
    overflowX: "hidden",
    overflowY: "auto"
  };
  
  const eventIdx = match?.params.eventIdx;
  
  useEffect(() => {
    // 이미 실행된 경우 스킵
    if (checkEventAccessCalled.current) {
      return;
    }
    
    // ✅ 즉시 ref를 true로 설정 (비동기 완료를 기다리지 않음)
    checkEventAccessCalled.current = true;
    
    // 로그인 확인 (Context auth 또는 Cookie auth)
    const isLoggedIn = auth || _CK.isLogin();
    
    if (isLoggedIn) {
      checkEventAccess();
      return;
    }
    
    // 로그인되지 않은 경우, WebSocket connectionId 체크
    // Windows Edge 등 DOM Storage 비활성 환경에서는 localStorage 접근이 SecurityError를 던지므로 감싼다.
    let wsConnectionId = null;
    try {
      wsConnectionId = localStorage.getItem('wsConnectionId');
    } catch (e) {
      /* DOM Storage 비활성 환경: connectionId 없음으로 처리 */
    }
    
    if (!wsConnectionId) {
      swal({
        title: "Notice",
        text: "WebSocket connectionId is required.",
        icon: "warning",
      }).then(() => {
        // 로그인 페이지로 이동
        window.location.href = `/#/site/${siteInfo.idx}/event/login`;
      });
      return;
    }
    
    checkEventAccess(); 
  }, []);

  useEffect(() => {

    const cData = cm.get(iam.preregIdx);

    if(eboothEventSetting != null && cData == null && cData == undefined){
      if(eventInfo?.eBoothUse == 'Y' && eboothEventSetting?.modalOpenUse == 'Y') {
        setEboothModalShow(true)
      }
    }

  }, [eboothEventSetting, eventInfo]);

  const initPage = () => {
    //애니메이션 설정 (gsap)
    if (typeof window !== `undefined`) {
      gsap.registerPlugin(ScrollTrigger);
      gsap.core.globals("ScrollTrigger", ScrollTrigger);

      ScrollTrigger.matchMedia({
        // desctop
        "(min-width: 768px)": function () {
          if (!document.querySelector(".sticky-wrap")) return;
          gsap.set(".sticky-wrap", {
            marginTop: -60,
            top: 0,
          });
          if (!document.querySelector(".button-register-wrap")) return;
          ScrollTrigger.create({
            trigger: ".button-register-wrap",
            start: "top top",
            // markers: true,
            onEnter: function () {
              gsap.to(".sticky-wrap", {
                marginTop: 0,
                duration: 0.35,
              });
            },
            onLeaveBack: function () {
              gsap.to(".sticky-wrap", {
                marginTop: -60,
                duration: 0.35,
              });
            },
          });
        },
        // mobile
        "(max-width: 767px)": function () {
          gsap.set(".sticky-wrap", {
            top: "120%",
            marginTop: -60,
          });
          ScrollTrigger.create({
            trigger: ".site",
            start: "top top",
            onEnter: function () {
              gsap.to(".sticky-wrap", {
                top: "100%",
                duration: 0.35,
              });
            },
            onLeaveBack: function () {
              gsap.to(".sticky-wrap", {
                top: "120%",
                duration: 0.35,
              });
            },
          });
        },
      });
    }
    const body = document.getElementById("body");
  };

  const loadEventData = () => {
    if (!siteInfo.idx || !eventIdx) {
      alert("올바른 접근이 아닙니다.");
      return;
    }
    const req = {
      path: "/v1/client/event/info",
      data: {
        siteIdx: siteInfo.idx,
        eventIdx,
      },
    };
    _API.post(req).then((res) => {
        const { data } = res;
        if (data) {
          // 이벤트 정보 셋팅
          setEventInfo(data);
          setEventInfoLoaded(true);
        } else {
          alert("이벤트 정보가 없습니다.");
          history?.push(`/site/${siteInfo.idx}/event/list`);
        }
      }).catch((e) => {
        history?.push(`/site/${siteInfo.idx}/event/list`);
      });
  };

  const loadSessionList = () => {
    if (!eventIdx) {
      return;
    }

    const req = {
      path: "/v1/client/session/list",
      data: {
        eventIdx : eventIdx,
        status: "Y",
        preregIdx: iam.preregIdx,
      },
    };

    _API.post(req).then((res) => {
      const { data } = res.data;

      if (data != null) {
        const pSessionList = [];
        for (let i in data) {
          const session = data[i];
          if (session.preregSessionIdx) {
            pSessionList.push(session);
          }
        }
        setSessionList(data);
        setPreregSessionList(pSessionList);
        setLoaded(true);
      }
    });
  };

  const setEboothSetting = async () => {
    const req = {
      path: "/v1/client/ebooth/settigs",
      data: {
        siteIdx: siteInfo.idx,
        eventIdx: eventIdx || match?.params.eventIdx,
      },
    };
    await _API.post(req).then((res) => {
      const { eboothEventSetting, eboothSiteSetting } = res.data;
      if(eboothSiteSetting != null){
        setEboothSiteSetting(eboothSiteSetting)
      }
      if(eboothEventSetting != null){
        setEboothEventSetting(eboothEventSetting)
      }
    }).catch((e) => {
      console.log(e)
    });
  };

  const loadEboothInfo = async () => {
    const req = {
      path: "/v1/client/ebooth/info",
      data: {
        eventIdx: eventIdx || match?.params.eventIdx,
        preregIdx : iam.preregIdx
      },
    };
    await _API.post(req).then((res) => {
      const { eboothSectionItem, eboothItem, _EBOOTH_LIST } = res.data;

     
      if(eboothSectionItem != null){
        setEboothSectionItem(eboothSectionItem)
      }
      if(eboothItem != null){
        setEboothItem(eboothItem)
      }
      if(_EBOOTH_LIST != null){
        setEboothList(_EBOOTH_LIST)
      }
    }).catch((e) => {
      console.log(e)
    });
  };

  const checkEventAccess = async (callback) => {
    // ✅ Context auth가 없으면 쿠키에서 가져옴 (새로고침 시)
    const authToken = auth || _CK.getAuth();
    
    const req = {
      path: "/v1/client/event/access/check",
      data: {
        siteIdx: siteInfo.idx,
        eventIdx: eventIdx || match?.params.eventIdx,
      },
      auth: authToken,
    };
    
    try {
      const result = await _API.post(req);

      const { accessKey, data } = result.data;
      if (data) {
        _CK.setAuth(accessKey);
        saveIam(data);
        // ✅ saveAuth 제거: index.js 재렌더링 방지 (SessionList 언마운트 방지)

        // ✅ 사전등록 정보 조회 (한 번만)
        if (data.preregIdx) {
          _API.prereg(data.preregIdx, accessKey)
            .then((preregResult) => setPreregInfo(preregResult.data))
            .catch((err) => console.error('[checkEventAccess] Failed to load preregInfo:', err));
        }
        
        // ✅ 초기 데이터 로딩 (React 18 자동 배칭으로 최소화)
        initPage();
        loadEventData();
        loadSessionList();
        setEboothSetting();
        loadEboothInfo();
      }
    } catch (e) {
      console.error('[checkEventAccess] Error:', e);
      if (iam?.targetType === "GUEST") {
        window.location.href = `/#/event/${iam.eventIdx}/register`;
        window.location.reload();
      } else if (iam?.targetType !== "GUEST") {
        history?.push(`/site/${siteInfo.idx}/event/list`);
      }
    }
  };

  useEffect(() => {
    if (_CK.getLogKey() == null) {
      alert("다시 로그인 해주세요.");
      _CK.setConsoleCountView(0);
      window.location.href = `/`;
    }
  }, [eventInfo]);
 
  const getTagList = () => {
    const req = {
      path: "/v1/client/session/tag/list",
      data: {
        eventIdx: eventIdx || match?.params.eventIdx,
      },
    };
    _API.post(req).then((res) => {
      const { data } = res.data;
      setTags(data);
    });
  }
  
  // ✅ useCallback으로 함수 메모이제이션 (재렌더링 시 함수 재생성 방지)
  const handleItemClick = useCallback((item) => {
    if(item == null){
      // 상태 업데이트를 반영하기 위해 brands 배열도 업데이트
      const updatedTagList = tags.map((tag) => {
        let newItem = {...tag};
        newItem.selected = allBtnSelected == true ? 0 : 1;
        return newItem;
      });
      // 상태 업데이트를 반영하기 위해 brands 배열도 업데이트
      const updatedSessionList = sessionList.map((session) => {
        let newItem = {...session};
        newItem.visible = allBtnSelected == true ? 0 : 1;
        return newItem;
      });
      setTags(updatedTagList);
      setSessionList(updatedSessionList);
      setAllBtnSelected((allBtnSelected == true) ? false : true)
    }else{
      // 상태 업데이트를 반영하기 위해 brands 배열도 업데이트
      const updatedTagList = tags.map((tag) => {
        let newItem = {...tag};
        if(newItem.tagName == item.tagName){
          newItem.selected = (newItem.selected == 1) ? 0 : 1;
        }
        return newItem;
      });

      let selectedTags = updatedTagList.filter((sTag) => sTag.selected == 1);
      // 상태 업데이트를 반영하기 위해 brands 배열도 업데이트
      const updatedSessionList = sessionList.map((session) => {
        let newItem = {...session};
        if(selectedTags.length == tags.length){
          newItem.visible = 1;
          return newItem;
        }else{
          // selectedTags 중 하나라도 session.tagName에 포함되어 있는지 확인
          let includes = selectedTags.some((sTag) => 
            newItem.tagName != null && newItem.tagName.includes(sTag.tagName)
          );
          newItem.visible = includes ? 1 : 0;
          return newItem;
        }
      });

      setTags(updatedTagList);
      setSessionList(updatedSessionList);
      if(updatedTagList.filter((item) => item.selected == 1).length == tags.length){
        setAllBtnSelected(true)
      }else{
        setAllBtnSelected(false)
      }
    }
  }, [tags, sessionList, allBtnSelected]); // ✅ 의존성 배열 추가

  useEffect(() => {
    loadSessionList();
    getTagList(); 
  }, []);
  
  if (!loaded || !eventInfoLoaded) {
    return (
            <LoadingShimmer />
    );
  }
  return (
    <Fragment>
      <SessionListDetail
        eventInfo={eventInfo}
        setEventInfo={setEventInfo}
        sessionList={sessionList}
        setSessionList={setSessionList}
        preregInfo={preregInfo}
        setAccompanySessionIdx={setAccompanySessionIdx}
        setAccompanyAttendModal={setAccompanyAttendModal}
        setSessionMgrInfoModalShow={setSessionMgrInfoModalShow}
        setManagerInfo={setManagerInfo}
        setEboothModalShow={setEboothModalShow}
        eboothEventSetting={eboothEventSetting}
        handleItemClick={handleItemClick}
        allBtnSelected={allBtnSelected}
        tags={tags}
      />
      {accompanyAttendModal && (
        <Modal modalClass="d-block" modalstyle={Modalstyle}>
          <RegisterAccompanyAttendModal
            eventIdx={eventIdx}
            sessionIdx={accompanySessionIdx}
            setAccompanyAttendModal={setAccompanyAttendModal}
          />
        </Modal>
      )}
      {sessionMgrInfoModalShow && (
        <Modal modalClass="d-block" modalstyle={Modalstyle}>
          <SpeakerModal
            managerInfo={managerInfo}
            setSessionMgrInfoModalShow={setSessionMgrInfoModalShow}
            defaultProfileImg={ImgPhoto}
            eventIdx={eventIdx}
          />
        </Modal>
      )}

      {eboothModalShow && (
        <Modal modalClass="d-block" modalstyle={Modalstyle}>
          <EboothModal
            setEboothModalShow={setEboothModalShow}
            eboothSiteSetting={eboothSiteSetting}
            eboothEventSetting={eboothEventSetting}
            eboothSectionItem={eboothSectionItem}
            eboothItem={eboothItem}
            eboothList={eboothList}
            loadEboothInfo={loadEboothInfo}
          />
        </Modal>
      )}
    </Fragment>
  );
};
